import { render, staticRenderFns } from "./PriceInformation.vue?vue&type=template&id=8363b7f0&scoped=true"
import script from "./PriceInformation.vue?vue&type=script&lang=js"
export * from "./PriceInformation.vue?vue&type=script&lang=js"
import style0 from "./PriceInformation.vue?vue&type=style&index=0&id=8363b7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363b7f0",
  null
  
)

export default component.exports